import * as React from 'react';

export function DiamondIcon() {
  return (
    <svg
      fill="none"
      height="13"
      viewBox="0 0 15 13"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.85 3.645L8.712.21H6.357L5.221 3.645h4.628zM3.016.21L.497 3.645h3.821L5.455.21H3.017zm11.555 3.434L12.052.21H9.616l1.137 3.434h3.82zm-3.61.867l-2.577 7.547 6.187-7.547h-3.61zM7.542 12.21l2.508-7.688H4.998l2.543 7.688zM.51 4.51l6.152 7.512-2.543-7.511H.509z"
        fill="#FFE384"
      />
    </svg>
  );
}
